import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarMonthsListControlFn = /* @__PURE__ */ createRecipe('calendar-months-list-control', {}, [])

const calendarMonthsListControlVariantMap = {}

const calendarMonthsListControlVariantKeys = Object.keys(calendarMonthsListControlVariantMap)

export const calendarMonthsListControl = /* @__PURE__ */ Object.assign(memo(calendarMonthsListControlFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarMonthsListControl',
  __getCompoundVariantCss__: calendarMonthsListControlFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarMonthsListControlVariantKeys,
  variantMap: calendarMonthsListControlVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarMonthsListControlVariantKeys)
  },
  getVariantProps: calendarMonthsListControlFn.getVariantProps,
})